export enum RequestType {
    Travel = 'travel',
    Stipend = 'stipend',
    Reimbursement = 'reimbursement',
}
